import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAgentState } from '@/context/agent-state.context';
import {
  invalidateOrpcPaths,
  readInvalidates,
} from '@/api/rpc/invalidateByPath';

/**
 * Refreshes the page after every server tool result that names the queries
 * it changed (`invalidates`: dotted contract paths). This is how an action
 * the assistant took shows up on the page without a manual refresh.
 */
export function useNamiInvalidationListener(): void {
  const queryClient = useQueryClient();
  const { registerToolResultListener } = useAgentState();
  useEffect(
    () =>
      registerToolResultListener((_toolCallId, _toolName, result) => {
        const paths = readInvalidates(result);
        if (paths && paths.length > 0) invalidateOrpcPaths(queryClient, paths);
      }),
    [registerToolResultListener, queryClient],
  );
}
